<div class="open-case-container">
  <div class="header">
    @if (width > 500) {
      <a class="header-back back-button" (click)="goBack()">
        <i class="fa-solid fa-chevron-left"></i>
        <div class="back text">{{ 'WebApp.v1.Shared.Buttons.Back' | translate }}</div>
      </a>

      <a routerLink="/available-surveys" class="header-logo">
        <img
          [src]="companyLogo()"
          (error)="getHowdyLogo()"
          [class.not-howdy]="!isHowdyLogo"
          class="logo"
          alt="logo"
        >
          <p class="text">{{ 'WebApp.v1.Shared.AwarenessByHowdy' | translate }}</p>
      </a>
    } @else {
      <app-pill class="header-pill"></app-pill>
    }
  </div>

  <div class="case-header">
    <div class="case-title">{{ 'WebApp.v1.OnDemand.OpenCase.Title' | translate }}</div>
    <div class="case-user">{{ account?.firstname }} {{ account?.lastname }}</div>
  </div>

  <div class="column-container">
    <div class="column small">
      <div class="details-box">
        <div class="details-title">{{ 'WebApp.v1.OnDemand.OpenCase.Details' | translate }}</div>
        @if (onDemandResponse?.openCaseData) {
          <div class="details-row">
            <span class="text">{{ 'WebApp.v1.OnDemand.OpenCase.Details.Status' | translate }}:</span>
            <span class="status assigned">{{ onDemandResponse?.openCaseData?.status }}</span>
          </div>
          <div class="details-row">
            <span class="text">{{ 'WebApp.v1.OnDemand.OpenCase.Details.CreatedOn' | translate }}:</span>
            <span class="link">{{ onDemandResponse?.openCaseData?.createdOn }}</span>
          </div>
          <div class="details-row">
            <span class="text">{{ 'WebApp.v1.OnDemand.OpenCase.Details.Psychologist' | translate }}:</span>
            <span class="link">{{ onDemandResponse?.openCaseData?.psychologist }}</span>
          </div>
          <div class="details-row">
            <span class="text">{{ 'WebApp.v1.OnDemand.OpenCase.Details.AttemptedCalls' | translate }}:</span>
            <span>{{ onDemandResponse?.openCaseData?.attemptedCalls }}</span>
          </div>
          <div class="details-row">
            <span class="text">{{ 'WebApp.v1.OnDemand.OpenCase.Details.LastCall' | translate }}:</span>
            <span class="link">{{ onDemandResponse?.openCaseData?.lastCallDate }}</span>
          </div>
          <div class="details-row">
            <span class="text">{{ 'WebApp.v1.OnDemand.OpenCase.Details.ExpectedNextCall' | translate }}:</span>
            <span class="link">{{ onDemandResponse?.openCaseData?.followUpDate }}</span>
          </div>
          <div class="details-row">
            <span class="text">{{ 'WebApp.v1.OnDemand.OpenCase.Details.CallerID' | translate }}:</span>
            <span class="link">{{ onDemandResponse?.openCaseData?.responseTeamNumber }}</span>
          </div> 
        } @else {
          @for (i of [1, 2, 3, 4, 5, 6, 7]; track i) {
            <div class="details-row skeleton"></div>
          }
        }
      </div>

      <div class="next-call-box">
        <div class="next-call-title">{{ 'WebApp.v1.OnDemand.OpenCase.Details.ExpectedNextCall' | translate }}</div>
        @if (onDemandResponse?.openCaseData?.followUpDate) {
          <div class="next-call-date">{{ onDemandResponse?.openCaseData?.followUpDate }}</div>
        } @else {
          <div class="next-call-date skeleton"></div>
        }
      </div>
    </div>

    <div class="column big">
      <div class="info-box">
        <div class="info-title">{{ 'WebApp.v1.OnDemand.OpenCase.Info' | translate }}</div>
        @if (onDemandResponse?.openCaseData?.createdOn) {
          <div class="info-text">
            {{ 'WebApp.v1.OnDemand.OpenCase.Info.InProgress' | translate: { date: onDemandResponse?.openCaseData?.createdOn } }}
          </div>
        } @else {
          @for (i of [1, 2, 3, 4]; track i) {
            <div class="info-text skeleton"></div>
          }
        }
      </div>
      <div class="note-box">
        <div class="note-title">{{ 'WebApp.v1.OnDemand.OpenCase.NoteToPsychologist' | translate }}</div>
        <div class="note-date">{{ onDemandResponse?.openCaseData?.noteDate }}</div>
        <div class="note-text-container">
          @if (editNote) {
            <textarea
              #textarea
              class="note-textarea"
              (input)="onNoteTextChange($event)"
              placeholder="{{ 'WebApp.v1.Shared.TextArea.WriteYourNote' | translate }}"
            ></textarea>
          } @else if (onDemandResponse?.openCaseData?.note) {
            <div class="note-text" style="width: 100%; text-align: left;">
              {{ onDemandResponse?.openCaseData?.note }}
            </div>
          } @else {
            @for (i of [1, 2, 3, 4]; track i) {
              <div class="note-text skeleton"></div>
            }
          }
        </div>

        @if (onDemandResponse?.openCaseData?.note) {
          @if (!editNote) {
            <app-button
              class="edit-note-btn"
              [label]="'WebApp.v1.Shared.Buttons.EditNote' | translate"
              backgroundColor="#1ec6e6"
              textColor="#fff"
              (click)="onEditNote()"
            ></app-button>
          } @else {
            <app-button
              class="edit-note-btn"
              [label]="'WebApp.v1.Shared.Buttons.SaveNote' | translate"
              backgroundColor="#1ec6e6"
              textColor="#fff"
              (click)="saveNote()"
            ></app-button>
          }
        }
      </div>
    </div>
  </div>
</div>
